export const coerceBreakdownIsMicroEnterprise = (ph: {
  proposer_type?: number | string;
  is_micro_enterprise?: unknown;
  micro_enterprise?: unknown;
}): number | null => {
  if (Number(ph?.proposer_type) !== 2) return null;
  const v = ph.is_micro_enterprise ?? ph.micro_enterprise;
  if (v === true || v === 1 || v === '1') return 1;
  if (v === false || v === 0 || v === '0') return 0;
  return null;
};

export const resolveBreakdownOldPolicyId = (
  modelObject: { oldPolicyId?: string; old_policy_id?: string },
  apiModelObject?: { id?: string; is_policy?: number },
  originalPolicyId?: string | null
): string | null =>
  modelObject?.oldPolicyId
  || modelObject?.old_policy_id
  || originalPolicyId
  || (Number(apiModelObject?.is_policy) === 1 ? apiModelObject?.id : null)
  || null;

export const isFirstBreakdownMtaSave = (
  modelObject: { id?: string; oldPolicyId?: string; old_policy_id?: string },
  apiModelObject: { id?: string; is_policy?: number },
  qType: number,
  originalPolicyId?: string | null
): boolean => {
  if (qType !== 3 && qType !== 4) return false;
  const policyId = resolveBreakdownOldPolicyId(modelObject, apiModelObject, originalPolicyId);
  const quoteId = modelObject?.id;
  return !!policyId && (!quoteId || quoteId === policyId);
};
